"use strict";

exports.__esModule = true;
exports.DeviceStatusController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RealtimeConnection = require("../../../API/RealtimeConnection");
var _Env = require("../../../Env");
var _dec, _class, _DeviceStatusController;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function createState(_ref) {
  var device = _ref.device;
  return {
    device: device,
    deviceTime: {
      value: 0,
      lastAt: 0
    },
    isDisconnected: false
  };
}
var DeviceStatusController = exports.DeviceStatusController = (_dec = _Env.EnvContext.withContext, _dec(_class = (_DeviceStatusController = /*#__PURE__*/function (_Component) {
  function DeviceStatusController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = createState(_this.props);
    _this.setStatusToDisconnected = function () {
      _this.setState({
        isDisconnected: true
      });
    };
    _this.resetConnectionTimer = function () {
      var _this$props$env;
      if (_this.connectionTimer) {
        clearTimeout(_this.connectionTimer);
        _this.connectionTimer = undefined;
      }
      _this.connectionTimer = setTimeout(function () {
        _this.setStatusToDisconnected();
      }, _this.props.connectionTimeout ? _this.props.connectionTimeout : (_this$props$env = _this.props.env) != null && _this$props$env.deviceConnectionTimeout ? _this.props.env.deviceConnectionTimeout : 40000);
    };
    _this.updateDeviceTimeInMillis = function (_ref2) {
      var value = _ref2.value;
      var deviceTimeInMillis = Date.parse(value);
      if (_this.state.deviceTime.value !== deviceTimeInMillis) {
        var state = {
          deviceTime: {
            value: deviceTimeInMillis,
            lastAt: Date.now()
          }
        };
        if (_this.state.isDisconnected) {
          state = Object.assign({}, state, {
            isDisconnected: false
          });
        }
        _this.setState(state, function () {
          _this.resetConnectionTimer();
        });
      }
    };
    return _this;
  }
  _inheritsLoose(DeviceStatusController, _Component);
  var _proto = DeviceStatusController.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.resetConnectionTimer();
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.connectionTimer);
    this.connectionTimer = undefined;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      device = _this$props.device,
      children = _this$props.children;
    return /*#__PURE__*/_react["default"].createElement(_RealtimeConnection.RealtimeDataSubscription, {
      params: ["deviceClock", {
        entity: {
          device: device.uuid,
          name: "time"
        }
      }],
      onData: this.updateDeviceTimeInMillis
    }, function () {
      return children(_this2.state);
    });
  };
  return DeviceStatusController;
}(_react.Component), _DeviceStatusController.defaultProps = {
  env: undefined
}, _DeviceStatusController)) || _class);